import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[login-company-host]',
})
export class LoginCompanyDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}